import {
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_MARKET_HOME,
  ROUTE_STOCKS_HOME,
} from '@/constants/routes';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

export const getTabLinkTo = ({
  to,
  toSubMarket,
  isLoggedIn,
  market,
}: {
  to: string;
  toSubMarket: string;
  isLoggedIn: boolean;
  market?: PrimaryCountryISOElseGlobal;
}) => {
  if (market === 'global') {
    if (to === ROUTE_DISCOVER_INVESTING_IDEAS && isLoggedIn === false) {
      // For logged out users only.
      // Discover > Investing Ideas hub is the main "global" market page.
      return { type: to, payload: {} };
    }
    if (to === ROUTE_STOCKS_HOME && isLoggedIn === false) {
      // For logged out users only.
      // Stocks page is the main "global" market page.
      return { type: to, payload: {} };
    }
    if (to === ROUTE_MARKET_HOME) {
      // Discover > Markets lacks a global market page so we link to the hub.
      return { type: to, payload: {} };
    }
  }

  // When a market is found use routes that include the market.
  return market
    ? { type: toSubMarket, payload: { market } }
    : { type: to, payload: {} };
};
